import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { FAQ } from '../components/FAQ';
import { WhatThisIsNot } from '../components/WhatThisIsNot';
import { FinalCTA } from '../components/FinalCTA';
export function PreguntasPage() {
  return <>
      <PageHeader eyebrow="Para que llegues con claridad" title="Preguntas frecuentes" data-id="element-579" />
      <FAQ data-id="element-580" />
      <WhatThisIsNot data-id="element-581" />
      <FinalCTA data-id="element-582" />
    </>;
}